export default __webpack_public_path__ + "static/media/two_bracelets.54212695.png";